import Microgame from '../engine/Microgame.js';

export default class BlowGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Souffle !`, en: `Blow!`, es: `¡Sopla!` },
            controls: { fr: `Appuie frénétiquement ou souffle dans le micro (si activé)`, en: `Tap very fast or blow into the microphone`, es: `Toca muy rápido o sopla en el micrófono` },
            objective: { fr: `Fais envoler le ballon avant la fin`, en: `Blow the balloon away before time ends`, es: `Haz volar el globo antes de que acabe el tiempo` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" stroke-width="2"><path d="M2.3 8a4 4 0 0 1 6.3 3.3.7.7 0 0 0 1.4 0 5.4 5.4 0 0 0-8.6-4.5"/><path d="M5 14h1.5a3.5 3.5 0 0 0 0-7H5"/><path d="M21.7 16a4 4 0 0 0-6.3-3.3.7.7 0 0 1-1.4 0 5.4 5.4 0 0 1 8.6 4.5"/><path d="M19 10h-1.5a3.5 3.5 0 0 1 0 7H19"/></svg>`,
            actions: [
                { type: 'hold', x: 50, y: 70, duration: 180, holdDuration: 1400 },
                { type: 'wait', duration: 360 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.flower = null;
        this.petals = [];
        this.isBlowing = false;
        this.windForce = 0;
    }

    setup() {
        this.engine.ui.instruction.textContent = "BLOW!";

        // Flower Center (Primary)
        const center = document.createElement('div');
        center.style.position = 'absolute';
        center.style.width = '60px';
        center.style.height = '60px';
        center.style.background = this.primaryColor;
        center.style.borderRadius = '50%';
        center.style.left = '50%';
        center.style.top = '50%';
        center.style.transform = 'translate(-50%, -50%)';
        center.style.boxShadow = `0 0 20px ${this.primaryColor}`;
        center.style.zIndex = '2';
        this.container.appendChild(center);

        // Petals (Secondary)
        const petalCount = 8;
        for (let i = 0; i < petalCount; i++) {
            const angle = (i / petalCount) * Math.PI * 2;
            const petal = document.createElement('div');
            petal.style.position = 'absolute';
            petal.style.width = '40px';
            petal.style.height = '80px';
            petal.style.background = this.secondaryColor;
            petal.style.borderRadius = '50% 50% 0 0';
            petal.style.left = '50%';
            petal.style.top = '50%';
            petal.style.transformOrigin = 'bottom center';
            // Initial position
            petal.style.transform = `translate(-50%, -100%) rotate(${angle}rad) translateY(-30px)`;
            petal.style.boxShadow = `0 0 10px ${this.secondaryColor}`;
            petal.style.zIndex = '1';

            // Store state
            petal.dataset.angle = angle;
            petal.dataset.detached = 'false';
            petal.dataset.vx = 0;
            petal.dataset.vy = 0;

            this.container.appendChild(petal);
            this.petals.push(petal);
        }

        this.onDown = this.onDown.bind(this);
        this.onUp = this.onUp.bind(this);

        this.engine.input.element.addEventListener('pointerdown', this.onDown);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
    }

    update(dt) {
        if (!this.active || this.won) return;

        if (this.isBlowing) {
            this.windForce += 5 * (dt / 1000);
        } else {
            this.windForce = Math.max(0, this.windForce - 2 * (dt / 1000));
        }

        let remaining = 0;

        this.petals.forEach(petal => {
            if (petal.dataset.detached === 'true') {
                // Fly away
                let vx = parseFloat(petal.dataset.vx);
                let vy = parseFloat(petal.dataset.vy);

                const x = parseFloat(petal.style.left) || 50; // %
                const y = parseFloat(petal.style.top) || 50; // %

                // Convert % to approximate px movement for simplicity
                // Just adding velocity to transform would be better but let's hack it
                // Actually, let's use transform for everything

                // We can't easily read current transform matrix.
                // Let's just animate opacity out and remove
                if (petal.style.opacity !== '0') {
                    petal.style.transition = 'transform 1s, opacity 0.5s';
                    petal.style.transform += ` translate(${vx * 100}px, ${vy * 100}px) rotate(${Math.random() * 360}deg)`;
                    petal.style.opacity = '0';
                }
                return;
            }

            remaining++;

            // Shake
            const angle = parseFloat(petal.dataset.angle);
            const shake = this.isBlowing ? (Math.random() * 10 - 5) : 0;

            // Detach logic
            // Each petal has a "strength" (random?)
            // Or just detach one by one based on windForce
            if (this.isBlowing && Math.random() < this.windForce * 0.1) {
                petal.dataset.detached = 'true';
                petal.dataset.vx = Math.cos(angle) * 5;
                petal.dataset.vy = Math.sin(angle) * 5;
            } else {
                petal.style.transform = `translate(-50%, -100%) rotate(${angle}rad) translateY(-30px) rotate(${shake}deg)`;
            }
        });

        if (remaining === 0) {
            this.win();
        }
    }

    onDown() {
        if (!this.active) return;
        this.isBlowing = true;
    }

    onUp() {
        this.isBlowing = false;
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onDown);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
    }
}
